/**
 * Styled Components - Created by cazarez on 07/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  color: #ffffff;
  font-size: 12px;
  line-height: 16px;
  font-weight: 200;
`

export const Title = styled.div`
  height: 14px;
  color: white;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 15px;
`

export const FooterLink = styled.div`
  margin-top: 32px;
  margin-bottom: 16px;
`

export const TitleBottom = styled.div`
  height: 14px;
  width: 119.29px;
  color: #bebebe;
  font-size: 10px;
  font-weight: bold;
  line-height: 14px;
  border-bottom: 1px solid #384952;
  padding-bottom: 20px;
  margin-bottom: 8px;
`

export const Text = styled.div`
  margin-bottom: 13px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SportsFooter/styledComponents.tsx